import React, { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import showToast from "../../components/Common/viewNotification"
import { useTranslation } from "react-i18next"
import {
  Col,
  Button,
  Row,
  Card,
  CardBody,
  ButtonGroup,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap"
import DataTable from "react-data-table-component"
import LinearIndeterminate from "../../components/Common/LinearIndeterminate"
import { initLoadTypes, initDeleteTypes, cleanType } from "../../store/actions"
import { is_empty } from "../../config/validate"
import { Link } from "react-router-dom"
import TypeForm from "./typeForm"

const TypeConcept = props => {
  const { currentConcept } = props
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [columns, setColumns] = useState([])
  const [selectRows, setSelectRows] = useState([])
  const [clearSelectedRows, setclearSelectedRows] = useState(false)
  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [auth] = useState(JSON.parse(sessionStorage.getItem("user")))
  const [currentType, setCurrentType] = useState(null)
  //#region  store
  const { types, loading, error, typessDelete } = useSelector(state => ({
    loading: state.Type.loading,
    types: state.Type.types,
    error: state.Type.error,
    typessDelete: state.Type.typesDelete,
  }))
  //#endregion

  useEffect(() => {
    if (!is_empty(error)) {
      showToast(error, "error", t("error:title"))
      dispatch(cleanType())
    }
  }, [error])

  useEffect(() => {
    if (typessDelete?.response?.length > 0) {
      setSelectRows([])

      showToast(t("type:msmdisable"), "success", t("type:title"))
      loadData()
    }
  }, [typessDelete])
  useEffect(() => {
    if (currentConcept) {
      loadData()
    }
  }, [currentConcept])
  //#region funciones
  const loadData = async () => {
    initColumns()
    await dispatch(initLoadTypes(currentConcept?.id))
  }
  const initColumns = () => {
    let col = [
      {
        name: "",
        // eslint-disable-next-line react/display-name
        cell: row => (
          <div className="d-flex gap-3">
            <Link className="text-success" to="#">
              <i
                className="fa fa-edit font-size-18"
                id="edittooltip"
                onClick={() => typeEdit(row)}
              ></i>
            </Link>
          </div>
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        width: "80px",
      },
      {
        name: t("concept:name"),
        sortable: false,
        wrap: true,
        grow: 2,
        // eslint-disable-next-line react/display-name
        cell: row => (
          <span>
            <h5 className="font-size-14 mb-1">
              <Link
                to="#"
                className="text-dark"
                onClick={() => typeEdit(row)}
              >
                {row.name}
              </Link>
            </h5>
          </span>
        ),
      },
      {
        name: t("concept:code"),
        sortable: false,
        wrap: true,
        grow: 1,
        // eslint-disable-next-line react/display-name
        cell: row => (
          <span>
            <div className="text-primary text-capitalize">{row.code}</div>
          </span>
        ),
      },
      {
        name: t("type:value"),
        sortable: false,
        wrap: true,
        grow: 3,
        // eslint-disable-next-line react/display-name
        cell: row => (
          <span>
            <div className="text-muted">{row.value}</div>
          </span>
        ),
      },
      {
        name: t("concept:state"),
        sortable: false,
        wrap: true,
        grow: 1,
        // eslint-disable-next-line react/display-name
        cell: row => (
          <>
            <span
              to="#"
              className={
                row.status === 1
                  ? "badge badge-soft-primary font-size-11 m-1"
                  : "badge badge-soft-danger font-size-11 m-1"
              }
            >
              {row.status === 1 ? t("global:active") : t("global:disable")}
            </span>
          </>
        ),
      },
    ]
    setColumns(col)
  }
  const toggle = () => {
    setModal(!modal)
  }

  const typeAdd = () => {
    setIsEdit(false)
    setCurrentType(null)
    toggle()
  }
  const typeEdit = row => {
    setModal(true)
    setIsEdit(true)
    setCurrentType(row)
    
  }
  const handleRowSelected = React.useCallback(state => {
    setSelectRows(state.selectedRows)
  }, [])

  const typeDisable = async () => {
    const ls = {
      createdBy: auth.id.user.username,
      rows: selectRows,
    }
    setclearSelectedRows(true)
    await dispatch(initDeleteTypes(ls))
    setclearSelectedRows(false)
  }

  //#endregion
  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <Row>
            <Col>
              <label className="text-primary text-uppercase font-size-16">
                <i className="fa fa-list font-size-18  me-1 " />
                {t("type:cardTitle")}
              </label>
            </Col>
            <Col>
              <div className="text-sm-end">
                <ButtonGroup>
                  <Button color="danger" onClick={typeDisable}>
                    <i className=" fas fa-times-circle me-1 " />
                    {t("global:setdisabled")}
                  </Button>

                  <Button
                    color="primary"
                    className="font-16 btn-block btn btn-primary"
                    onClick={typeAdd}
                  >
                    <i className="fas fa-plus-circle me-1" />
                    {t("global:add")}
                  </Button>
                </ButtonGroup>
              </div>
            </Col>
          </Row>
          <DataTable
            columns={columns}
            data={types}
            fixedHeader
            fixedHeaderScrollHeight="500px"
            dense
            selectableRows={true}
            onSelectedRowsChange={handleRowSelected}
            highlightOnHover
            pagination
            progressPending={loading}
            progressComponent={<LinearIndeterminate />}
            clearSelectedRows={clearSelectedRows}
            noDataComponent={t("tableOptions:noDataComponent")}
            paginationComponentOptions={{
              rowsPerPageText: t("tableOptions:rowsPerPageText"),
              rangeSeparatorText: t("tableOptions:rangeSeparatorText"),
              selectAllRowsItem: true,
              selectAllRowsItemText: t("tableOptions:selectAllRowsItemText"),
            }}
          />
          <Modal isOpen={modal} toggle={toggle} backdrop={"static"}>
            <ModalHeader toggle={toggle} tag="h4" close={<span></span>}>
              {t("type:add")}
            </ModalHeader>
            <ModalBody>
              <TypeForm
                onClosing={toggle}
                isEdit={isEdit}
                currentType={currentType}
                onLoad={loadData}
                currentConcept={currentConcept}
              />
            </ModalBody>
          </Modal>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}
export default TypeConcept
